import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "./MobileFilter.scss";
import filtericon from "../../../../assets/icons/search/filter.svg";
import Filter from "./Filter";
import { useAppDispatch, useAppSelector } from "store/store";
import { searchSelector, activeFilters } from "features/search-property/searchproperty.slice";
import { clearSearchResult } from "features/search-result/searchresult.slice";
import useClickOutside from "hooks/useClickOutside";

interface IMobileFilter { amenities: [] }

const MobileFilter: React.FC<IMobileFilter> = ({ amenities }) => {
  const { t } = useTranslation(); 
  const [formOpen, setOpen] = useState(false);
  const dispatch = useAppDispatch();
  const { mobFilters } = useAppSelector(searchSelector);
  const node = React.useRef<HTMLDivElement>(null);

  const applyFilter = () => {
    const params = { ...mobFilters };
    dispatch(activeFilters(params));
    dispatch(clearSearchResult());
  }

  useClickOutside(node, () => { setOpen(false); })
  return (
    <>
      <div className="container" id="app" ref={node as any}>
        <div className={`add-product ${formOpen ? "open" : ""}`}>
          <div
            className="button-copy"

            onClick={() => {
              setOpen(true);
            }}
          >
            <img alt="alt filler"
              src={filtericon}
              className={`filtericon hide-small ${formOpen ? "open" : ""}`}
            ></img>
          </div>

          <form>
            {/* <div className="mobile-filter-header">
              Filter and Sort <span className="reset-filter" onClick={resetFilter}>Reset</span>
            </div> */}
            <Filter amenities={amenities} setOpen={setOpen}></Filter>
            <div className="apply-filter-container">
              <div className="apply-filter"
                onClick={() => {
                  setOpen(false);
                  applyFilter();
                }}>
                <span
                >
                  {t('searchResults.applyFilter')}
                </span>
              </div>
            </div>
            {/* <div className="cancel">
              <span
                onClick={() => {
                  setOpen(false);
                }}
              >
                Cancel
              </span>
            </div> */}
          </form>
        </div>
      </div>
    </>
  );
};

export default MobileFilter;
